import React from 'react';
import classNames from 'classnames';
import './vertical-divider.scss';

interface VerticalDividerProps {
  className?: string;
}

export const VerticalDivider = ({ className = '' }: VerticalDividerProps) => (
  <div className={classNames('common-vertical-divider', className)} data-testid="common-vertical-divider"></div>
);
